/* eslint-disable react/prop-types */
/* eslint-disable global-require */
import React from 'react'
import './Nav.scss'

class Nav extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { itemArr } = this.props
    return (
      <nav id="navbar" className="navbar navbar-expand-xl fixed-top navbar-dark py-3">
        <div className="container">
          <a className="navbar-brand" href="###">
            <img src={require('../assets/img/logo/rtc.svg')} className="" alt="" />
            <img src={require('../assets/img/logo/agora.svg')} className="ml-3 d-none d-sm-inline-block" alt="" />
          </a>
          <a
            className="btn btn-primary d-flex d-xl-none ml-auto mr-2"
            href="https://github.com/AgoraIO-Community/RTC-Hackathon"
          >
            赛后报道
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto">
              {itemArr.map((item, index) => {
                return (
                  <li key={item.id} className={`nav-item ${index === itemArr.length - 1 && 'mr-2'}`}>
                    <a className="nav-link" href={item.id}>
                      {item.name}
                    </a>
                  </li>
                )
              })}
              <li className="nav-item d-none nav-item-shrink">
                <a
                  className="btn btn-primary"
                  href="https://github.com/AgoraIO-Community/RTC-Hackathon"
                  target="_blank"
                >
                  赛后报道
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    )
  }
}

export default Nav
